import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { google } from '@shared/models/googlemaps.model';
import DirectionsLeg = google.maps.DirectionsLeg;

@Component({
  selector: 'rlst-drive-direction-window',
  templateUrl: './drive-direction-window.component.html',
  styleUrls: ['./drive-direction-window.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DriveDirectionWindowComponent {
  @Input() leg: DirectionsLeg;
  @Output() clearDirections: EventEmitter<void> = new EventEmitter<void>();
  @Output() closeWindow: EventEmitter<void> = new EventEmitter<void>();
  @Output() sendEmailDriveDirection: EventEmitter<void> = new EventEmitter<void>();

  public clear(): void {
    this.clearDirections.emit();
  }

  public close(): void {
    this.closeWindow.emit();
  }

  public sendEmail(): void {
    this.sendEmailDriveDirection.emit();
  }
}
